<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { faLightbulbOn } from '@fortawesome/duotone-regular-svg-icons'

const { t } = useI18n()
</script>

<template>
  <div class="font-inter prose-h3:mt-0 mt-12 flex items-start bg-[#f29a46] py-10 pr-16 text-blue-50">
    <div class="mr-5 ml-8 flex items-start text-5xl">
      <font-awesome-icon :icon="faLightbulbOn" />
    </div>
    <div class="w-full">
      <h3
        class="text-2xl font-bold text-blue-50"
        v-text="t('header.teacherGuide.tip')"
      />
      <slot />
    </div>
  </div>
</template>
